export default  {
    component: 'tracker',
    name: 'tracker',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Block ID',
            param: 'block_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> Should always start from ID **"1"**`
          },
          {
            name: 'Tracker ID',
            param: 'tracker_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each block, tracker id should start from **"1"**`
          },
          {
            name: 'Device ID',
            param: 'device_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each block, tracker id should start from **"1"**`
          },
          {
            name: 'Tracker Name',
            param: 'tracker_name',
            type: 'text',
            description: `> For each tracker device name should be unique`
          },
          {
            name: 'Latitude',
            param: 'latitude',
            type: 'number',
          },
          {
            name: 'Longitude',
            param: 'longitude',
            type: 'number',
          },
          {
            name: 'Tracker Count',
            param: 'tracker_count',
            type: 'number',
          },
          {
            name: 'Param Config',
            param: 'param_config',
            type: 'json',
            description: `Name, count can be added in json.
            - Json: e.g: [{"mode_status": {"op": {"0": "Non Recognised", "1": "Auto", "2": "Remote Manual", "3": "NFC", "4": "Halt", "5": "Wind Defence", "6": "Low Battery Stop", "7": "Fault stop", "8": "Local Emergency Stop", "9": "Remote Emergency Stop", "10": "TBox Communications Lost", "11": "Local Manual"}, "name": "Operation Mode"}, "actual_angle": {"count": 29, "nameMap": ["Dbox1", "Dbox2", "Dbox3", "Dbox4", "Dbox5", "Dbox6", "Dbox7", "Dbox8", "Dbox9", "Dbox10", "Dbox11", "Dbox12", "Dbox13", "Dbox14", "Dbox15", "Dbox16", "Dbox17", "Dbox18", "Dbox19", "Dbox20", "Dbox21", "Dbox22", "Dbox23", "Dbox24", "Dbox25", "Dbox26", "Dbox27", "Dbox28", "Dbox29"], "multiple": true}, "target_angle": {"count": 5, "nameMap": ["Dbox-31", "Dbox-32", "Dbox-33", "Dbox-34", "Dbox-35"], "multiple": true}}]`
          },
          {
            name: 'Parameter List',
            param: 'param_list',
            type: 'text',
            description: `> In order to remove unwanted parameters from analytics. *\(e.g rm-current,rm-deviation_angle)`
          },
          {
            name: 'Make',
            param: 'make',
            type: 'text',
          },
          {
            name: 'Name Config',
            param: 'name_config',
            type: 'text',
            description: `The name should be unique. Name Concatination of blockname-devicename`
          },
    ]
  }


